import { useMutation } from "@tanstack/react-query";
import TenantHandler from "../handlers/tenant";

const useConfusionMatrix = (onSuccess, onFailure, onPending) => {
	const tenantHandler = new TenantHandler();

	const { data, isPending, isSuccess, isError, error, mutate } = useMutation({
		mutationFn: (payload) => tenantHandler.getConfusionMatrix(payload),
		onSuccess: onSuccess,
		onError: onFailure,
		onMutate: onPending,
	});

	return { data, isPending, isSuccess, isError, error, mutate };
};

export default useConfusionMatrix;
